import { useMemo } from 'react';
import { useIsFeatureEnabled } from '@shared/core/featureFlags';

interface UseIsAccommodationsTourEnabledReturn
  extends Readonly<{
    isAccommodationsTourEnabled: boolean;
    asyncHotelAutopopulationEnabled: boolean;
    isLoading: boolean;
  }> {}

/**
 * Hook to check if the accommodations tour is enabled.
 */
export const useIsAccommodationsTourEnabled = (): UseIsAccommodationsTourEnabledReturn => {
  const [asyncHotelAutopopulationEnabled, loadingAsyncHotelAutopopulationEnabled] = useIsFeatureEnabled('asyncHotelAutopopulationEnabled');

  const [isLighterWeightTourEnabled, loadingLighterWeightTourEnabled] = useIsFeatureEnabled('accommodationsLighterWeightTour', {
    skip: !asyncHotelAutopopulationEnabled,
  });

  return useMemo(
    () => ({
      isAccommodationsTourEnabled: isLighterWeightTourEnabled,
      asyncHotelAutopopulationEnabled,
      isLoading: loadingAsyncHotelAutopopulationEnabled || loadingLighterWeightTourEnabled,
    }),
    [isLighterWeightTourEnabled, asyncHotelAutopopulationEnabled, loadingAsyncHotelAutopopulationEnabled, loadingLighterWeightTourEnabled],
  );
};
